var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  ScreenAdd: () => ScreenAdd
});
var import_definition = __toModule(require("../definition"));
var import_screen = __toModule(require("./screen"));
var import_addMapper = __toModule(require("../summary/forms/addMapper"));
class ScreenAdd extends import_screen.Screen {
  constructor(samaData, samaForm, screenName, navigationIndex) {
    super(samaData, samaForm, screenName, navigationIndex);
    this.samaData = samaData;
    this.samaForm = samaForm;
    this.screenName = screenName;
    this.navigationIndex = navigationIndex;
    if (!import_addMapper.AddMapper.isScreenAdd(screenName)) {
      throw new Error("Invalid screenName for ScreenAdd type");
    }
    this.form = import_addMapper.AddMapper.getScreenModel(screenName);
  }
  add() {
    if (!this.getSelectedOption()) {
      return { id: this.getNext(), index: this.getNavigationIndex() };
    }
    const cardGroup = this.samaForm.getCardForm(this.getSelectedOption());
    const editScreen = this.samaForm.getScreenForm(cardGroup.editScreenId);
    const yayoyakisFormArray = this.samaForm.getYayoyakisArrayForm(cardGroup.yayoyakiSiblingsId);
    const newIndex = this.samaData.addValues(yayoyakisFormArray);
    const screenId = (editScreen == null ? void 0 : editScreen.screenType) === import_definition.ScreenTypes.SUMMARY ? editScreen.addScreen : cardGroup.editScreenId;
    return { id: screenId, index: newIndex };
  }
  isDataValid() {
    var _a;
    return !((_a = this.form.validations) == null ? void 0 : _a.required) || !!this.selectedValue;
  }
  getOptions() {
    return this.form.options;
  }
  getSelectedOption() {
    return this.selectedValue;
  }
  setSelectedOption(value) {
    if (!this.getOptions().some((option) => option.value === value) && value !== void 0) {
      throw new Error(`ScreenAdd: value ${value} is not valid`);
    }
    this.selectedValue = value;
  }
  getCardGroupFormId() {
    var _a;
    return (_a = this.samaForm.getCardForm(this.getSelectedOption())) == null ? void 0 : _a.id;
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ScreenAdd
});
